<script setup lang="ts">
  import { useBranchesList } from '@/models/branch'

  withDefaults(defineProps<{
    required?: boolean,
    placeholder?: string,
    showAllOption?: boolean,
  }>(), {
    showAllOption: true,
    placeholder: 'Pilih Cabang',
  })

  const modelValue = defineModel<number | null>()

  const { branches, loading, getData } = useBranchesList()
  getData()

</script>

<template>
  <app-select
    v-model="modelValue"
    label="Cabang"
    :placeholder="placeholder"
    :loading="loading"
    :required="required">
    <option
      v-if="showAllOption"
      :value="undefined">
      Semua
    </option>
    <option
      v-for="branch in branches"
      :key="branch.id"
      :value="branch.id">
      {{ branch.code }}
    </option>
  </app-select>
</template>
